import getDateObjectFromDateStringOrDateObject from "./getDateObjectFromDateStringOrDateObject";
import { Dispatch } from "vuex";
import isAnyDayBlackedOut from "./isAnyDayBlackedOut";
import { HscStoreState } from "../../hsc/defs";
import { HotelRoomState } from "../hotel-rooms";
import { HotelViewRoomDetailsState } from "../../view-room-details/defs";

export default function vuexUpdateCheckOutDate<T extends HscStoreState | HotelRoomState | HotelViewRoomDetailsState>() {
  return async function(
    { dispatch, state }: { dispatch: Dispatch, state: T },
    checkOutDate: string | Date | null
  ): Promise<void> {
    if (null === checkOutDate) {
      state.checkOutDate = null;
    } else {
      let newCheckOutDate = getDateObjectFromDateStringOrDateObject(checkOutDate);
      if (!state.checkInDate) {
        dispatch("updateCheckInDate", newCheckOutDate);
      } else if (newCheckOutDate) {
        const daysBetweenCheckInAndCheckOut = Math.abs(window.pepDateFunctions.daysBetween(state.checkInDate, newCheckOutDate));
        if (isAnyDayBlackedOut(state.calendarData, state.checkInDate, newCheckOutDate)) {
          throw new Error("Selected dates contain an unavailable date.");

        } else if (state.minDays === state.maxDays && (daysBetweenCheckInAndCheckOut > state.maxDays || daysBetweenCheckInAndCheckOut < state.minDays)) {
          throw new Error("Stay length must be exactly" + state.maxDays + " days.");

        } else if (daysBetweenCheckInAndCheckOut > state.maxDays) {
          throw new Error("Stay length must be less than or equal to " + state.maxDays + " days.");

        } else if (daysBetweenCheckInAndCheckOut < state.minDays) {
          throw new Error("Stay length must be at least " + state.minDays + " days.");

        } else {
          if (newCheckOutDate.getTime() < state.checkInDate.getTime()) {
            const tmpCheckInDate = new Date(state.checkInDate);
            state.checkInDate = newCheckOutDate;
            newCheckOutDate = tmpCheckInDate;
          }

          if (null !== state.bookingLinkData) {
            state.bookingLinkData.end = newCheckOutDate.getFullYear() + '-' +
              String(newCheckOutDate.getMonth() + 1).padStart(2, '0') + '-' +
              String(newCheckOutDate.getDate()).padStart(2, '0');
          }
          state.checkOutDate = newCheckOutDate;
        }
      }
    }
  };
}